<template>
    <div>
        <div class="card bg-secondary border-0 mb-0">
            <div class="card-body px-lg-5 py-lg-5">

                <validation-observer v-slot="{ invalid, handleSubmit }" ref="passwordValidator">
                    <form role="form" @submit.prevent="handleSubmit(submit)" @keydown="form.errors.clear($event.target.name)">

                        <base-input alternative class="mb-3"
                            name="email"
                            :rules="{required: true, email: true}"
                            prepend-icon="tim-icons icon-mail"
                            :placeholder="$t('auth.email-placeholder')"
                            v-model="form.data.email"
                            :error="form.errors.get('email')"
                        >
                        </base-input>

                        <base-input alternative class="mb-3"
                            type="password"
                            name="password"
                            :rules="{required: true, min: 8}"
                            prepend-icon="tim-icons icon-access-key"
                            :placeholder="$t('auth.new-password')"
                            v-model="form.data.password"
                            :error="form.errors.get('password')"
                        >
                        </base-input>

                        <base-input alternative class="mb-3"
                            type="password"
                            name="password_confirmation"
                            :rules="{required: true, min: 8, confirmed: 'password'}"
                            prepend-icon="tim-icons icon-access-key"
                            :placeholder="$t('auth.new-password-confirm')"
                            v-model="form.data.password_confirmation"
                            :error="form.errors.get('password_confirmation')"
                        >
                        </base-input>

                        <div class="text-center pt-2">
                            <base-button type="primary"
                                native-type="submit"
                                :disabled="form.errors.any() || invalid"
                                :loading="form.recording"
                            >
                                {{ $t('auth.save-password') }}
                            </base-button>
                        </div>

                    </form>
                </validation-observer>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-6">
                <router-link to="/astral/ui/login" class="text-light">
                    <small>{{ $t('auth.know-my-password') }}</small>
                </router-link>
            </div>
            <div class="col-6 text-right">
                <a href="mailto:astral@enac.fr" class="text-light">
                    <small>{{ $t('common.contact') }}</small>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    import CrudClient from '@trax/classes/CrudClient'
    import CrudForm from '@trax/classes/CrudForm'

    export default {

        props: {
            redirectRouteName: {
                type: String,
                required: true
            }
        },

        data() {
            let client = new CrudClient('/trax/api/auth/password/reset')
            return {
                form: new CrudForm(client, this.mapData, this.unmapData),
            }
        },

        created() {
            this.form.create().then(this.succeeded)
        },

        methods: {

            mapData() {
                return {
                    email: null,
                    password: null,
                    password_confirmation: null,
                    token: this.$route.params.token,
                }
            },

            unmapData(data) {
                return data
            },

            submit() {
                this.form.created()
            },

            succeeded() {
                this.$router.push({ name: this.redirectRouteName });
            }
        }
    }
</script>
